// Display prices for the public plan/pricing UI (/pricing and the homepage's Compare plans
// section, via PricingCompare). Change them here and both pages follow.
//
// Also KEEP IN SYNC with the /pricing title/description in src/seo/routeMeta.js (it can't
// import this: vite.config.js reads routeMeta at build time) and with the Stripe price the
// plan step actually charges (VITE_STRIPE_LIGHT_USER_YEARLY_PRICE_ID / monthly equivalent).
export const MONTHLY_PRICE = 9.99;
export const YEARLY_PRICE = 39.99;
export const YEARLY_PER_MONTH = (YEARLY_PRICE / 12).toFixed(2);
export const YEARLY_SAVING = (MONTHLY_PRICE * 12 - YEARLY_PRICE).toFixed(2);
